<template>
  <div>
    <div class="application5">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application5-1.jpg" alt />
          <img src="../../assets/images/application/application5-2.jpg" alt />
          <img src="../../assets/images/application/application5-3.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application5">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>智慧场馆安防、智慧社区安防、智慧公安安防等。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>基于BIM、GIS可视化技术和物联网技术，整合视频监控信息，运用视频识别和AI分析技术，实现智能安防管理平台。 将安防相关的门禁、告警、设备设施、车辆、人员、资产、房屋等信息通过物联接口进行对接集成，最终实现一张图统一管理，实现所见即所得地扁平化管理，提升安防管理响应能力，节约安防资源，提升工作效率。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`application5-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Application5",
  metaInfo: {
    title:
      "智慧安防可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧安防,智慧安防可视化,安防三维可视化,安防三维地图,安防BIM"
      },
      {
        name: "description",
        content: "基于BIM、GIS可视化技术和物联网技术,整合视频监控信息,运用视频识别和AI分析技术,实现智能安防管理平台。 将安防相关的门禁、告警、设备设施、车辆、人员、资产、房屋等信息通过物联接口进行对接集成,最终实现一张图统一管理,实现所见即所得地扁平化管理,提升安防管理响应能力,节约安防资源,提升工作效率。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧安防可视化管理",
        p:
          "基于BIM、GIS可视化技术和物联网技术，整合视频监控信息，运用视频识别和AI分析技术，实现智能安防管理平台。 将安防相关的门禁、告警、设备设施、车辆、人员、资产、房屋等……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "智慧场馆安防、智慧社区安防、智慧公安安防等。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于BIM、GIS可视化技术和物联网技术，整合视频监控信息，运用视频识别和AI分析技术，实现智能安防管理平台。 将安防相关的门禁、告警、设备设施、车辆、人员、资产、房屋等信息通过物联接口进行对接集成，最终实现一张图统一管理，实现所见即所得地扁平化管理，提升安防管理响应能力，节约安防资源，提升工作效率。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/application5/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application5 {
  font-size: 0;
  img {
    &:nth-child(1) {
      width: 584px;
      margin-right: 20px;
    }
    &:nth-child(2) {
      width: 584px;
    }
    &:nth-child(3) {
      margin-top: 20px;
      width: 100%;
    }
  }
}
.mobile-application5 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application5 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application5 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application5.vue